<template>
  <div class="contact">
    <br><br><br><br>
    <div class="container">
      <div>
        <h1 class="display-3 heading">Contact us</h1>
        <hr class="featurette-divider" />
        <iframe
          id="map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d589.1943665123482!2d-1.768852378677429!3d53.79344727991243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487be6b6eb1ef465%3A0x6144e0e8a0186c63!2sVantage%20Cargo!5e0!3m2!1sen!2suk!4v1645051135493!5m2!1sen!2suk"
          allowfullscreen="yes"
          loading="lazy"
        ></iframe>
        <hr class="featurette-divider" />
        <div class="container">
          <div class="row" id="contactinfo">
            <div class="col">
              <h5><font-awesome-icon icon="fa-solid fa-map-location-dot" /> Find Us</h5>
              <p>Vantage Cargo, Unit 55, Listerhills Science Park, Campus Road, Bradford, BD7 1HR, West Yorkshire</p>
              <hr class="featurette-divider" />
              <h5><font-awesome-icon icon="fa-solid fa-phone" /> Call Us</h5>
              <p>++44-1274-722722</p>
              <hr class="featurette-divider" />
              <h5><font-awesome-icon icon="fa-solid fa-envelope" /> Email Us</h5>
              <p>info@vantagecargo.com (All Queries)<br>
              ops@vantagecargo.com (Operations)<br>
              sales@vantagecargo.com (Sales)</p>
            </div>
            <div class="col">
              <h3><font-awesome-icon icon="fa-solid fa-pen" /> Send us a message</h3>
              <form id="contactform" ref="form" @submit.prevent="sendEmail">
                <input type="text" v-model="name" name="name" placeholder="Name" /><br>
                <input type="email" v-model="email" name="email" placeholder="Email" /><br>
                <input type="phone" v-model="phone" name="phone" placeholder="Phone Number (Optional)" /><br>
                <textarea id="query" v-model="message" name="message" placeholder="Query"></textarea><br>
                <input type="submit" :disabled="!name || !email || !message" @click="$bvModal.show('confirmation')" class="btn btn-primary btn-lg submit" value="Send">
                <!--MODAL-->
                <div>
                  <b-modal id="confirmation" centered hide-footer>
                    <template #modal-header>
                      <h4 class="text-center">Message Sent!</h4>
                    </template>
                    <div class="d-block text-center">
                      <p>Thank you, your query has been sent! We will try to get back to you as soon as possible.</p>
                    </div>
                    <b-button id="close" class="mt-3" block @click="$bvModal.hide('confirmation')">Close</b-button>
                  </b-modal>
                </div>
                <!--MODAL END-->
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import emailjs from 'emailjs-com';
export default {
  name: 'ContactUs',
  data() {
    return {
      name: '',
      email: '',
      phone: '',
      message: ''
    }
  },
  methods: {
    sendEmail() {
      if (this.name == null) {
        alert("Please give us your name and either your email or phone so we can get back to you!");
        return false;
      }
      emailjs.sendForm('service_7ldpoe4', 'template_hueh4rh', this.$refs.form, '9BL6Xy4taCCEuuSBI', {
          name: this.name,
          email: this.email,
          phone: this.phone,
          message: this.message
      })
      this.name = ''
      this.email = ''
      this.phone = ''
      this.message = ''
    },
  }
}
</script>